export function scoped(namespace: string, id: string | null): string | null {
    return id ? `${namespace}:${id}` : null;
}